<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotoactivity()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Manage Activity
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row d-flex justify-content-center">
        <div class="col-sm-12 col-md-5 mt-4">
            <mat-form-field appearance="fill" hideRequiredMarker>
                <mat-label>Name</mat-label>
                <input matInput appInputtext maxlength="25" formControlName="activityName"
                    placeholder="Activity Name" class="col-10" autocomplete="off">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-2"></div>
        <div class="col-sm-12 col-md-8 col-xl-9 mt-5">
          <div class="col-sm-12 col-md-6" style="display: flex; align-items: center;">
            <label style="margin-right: 30px; font-size: large; white-space: nowrap;">Email Required</label>
            <mat-checkbox formControlName="isEmailRequired" style="transform: scale(1.3);" color="primary"></mat-checkbox>
            <label style="margin-left: 30px; font-size: large; white-space: nowrap;">
              Is this activity require Email reminder for the person responsible?
            </label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end button-style mt-5 mr-5">
        <button class="btn btn-primary mb-3 mr-3" type="button" (click)="gotoactivity()"
            matButton>Cancel</button>
        <button class="btn btn-secondary mb-3" type="submit" (click)="save()"
            matButton>Save</button>
    </div>
        </form>
        </div>
      </div>
    